import ApiConstants from "../../Constants/ApiConstant";
import { apiGet } from "../../Services/ApiService";

export const getLandingPageContentAPI = (params, callBack) => {
  return async () => {
    let url = ApiConstants.getLandingPageContentUrl;
    const queryParams = [];

    if (params?.user_id)
      queryParams.push(`user_id=${encodeURIComponent(params.user_id)}`);
    if (params.limit)
      queryParams.push(`limit=${encodeURIComponent(params.limit)}`);
    if (params.flag_web)
      queryParams.push(`flag_web=${encodeURIComponent(params.flag_web)}`);
    if (params.root_key)
      queryParams.push(`root_key=${encodeURIComponent(params.root_key)}`);


    // Append query parameters to URL if they exist
    if (queryParams?.length > 0) {
      url += `?${queryParams.join("&")}`;
    }
    try {
      await apiGet(url)
        // await apiGet(`${ApiConstants.getLandingPageContentUrl}?rootKey=web`) 
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("Error fetching landing page content:", err);
          throw err;
        });
    } catch (err) {
      console.log("Error fetching landing page content:", err);
      throw err;
    }
  };
};
